import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { bffErrorCode } from '../../../core/api/bff-error';
import { BffService } from '../../../core/services/http/bff.http.service';
import { IonicStorageService } from '../../../core/services/storage/ionic/storage.service';
import { SHELL_HOME_URL } from '../../../core/shell/shell-routes.constant';
import { IS_FAILED_SUBSCRIPTION } from 'src/app/shared/common/constants';
import { MAX_RETRY_ATTEMPTS } from '../../constants/error-state.constant';
import { FAILED_TEXTS } from '../../constants/failed.constant';
import { SUBSCRIPTION_URLS } from '../../constants/subscription-routes.constant';
import { SUBSCRIPTION_STORAGE_KEYS } from '../../constants/subscription-storage.constant';
import { SubscriptionService } from '../../services/subscription.service';

const BUTTONS_OPTIONS = {
  MODIFY: 'modify',
  STOP: 'stop',
};

@Component({
    selector: 'app-failed-page',
    templateUrl: './failed.page.html',
    standalone: false
})
export class FailedPage implements OnInit {
  readonly texts = FAILED_TEXTS;

  attempts: number = 0;

  isLoading: boolean = false;
  codeError: string = '';
  areButtonsDisabled: boolean = false;
  showModifySpinner: boolean = false;
  showStopSpinner: boolean = false;

  constructor(
    private readonly bffService: BffService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly ionicStorageService: IonicStorageService,
    private readonly subscriptionSvc: SubscriptionService
  ) {}

  ngOnInit(): void {
    this.codeError =
      sessionStorage.getItem(SUBSCRIPTION_STORAGE_KEYS.errorCode) ?? '';
  }
  get canRetry(): boolean {
    return this.attempts < MAX_RETRY_ATTEMPTS;
  }

  get subtitle(): string {
    return this.canRetry
      ? this.texts.subtitle
      : this.texts.subtitleWithoutRetries;
  }

  goHome(): void {
    this.router.navigate([SHELL_HOME_URL]);
  }

  async tryAgainSubscription(): Promise<void> {
    if (!this.canRetry || this.isLoading) return;

    this.attempts += 1;
    this.isLoading = true;

    try {
      await this.subscriptionSvc.retry();
      this.router.navigate([SUBSCRIPTION_URLS.success]);
    } catch (error) {
      console.error('Error retrying subscription', error);
      this.codeError = bffErrorCode(error);
      this.isLoading = false;
    }
  }

  async goToModifyOrStop(stopOrModify: string) {
    try {
      this.areButtonsDisabled = true;

      if (stopOrModify === BUTTONS_OPTIONS.MODIFY) {
        this.showModifySpinner = true;
      } else {
        this.showStopSpinner = true;
      }

      const subscription: any = JSON.parse(
        String(sessionStorage.getItem(SUBSCRIPTION_STORAGE_KEYS.pending))
      );

      const response = await this.bffService.getUnfilteredSubscriptions();

      const employerToLookFor = String(
        subscription.employer.rut + subscription.employer.checkDigit
      );

      const currentSubscription = response.data?.data?.result?.data.find(
        (sub: any) =>
          String(sub.employerRut.replace(/^0+/, '')) === employerToLookFor
      );

      if (!currentSubscription) {
        console.warn('Subscription not found');
        this.resetDisabledAndSpinners();
        return;
      }

      await this.ionicStorageService.set(IS_FAILED_SUBSCRIPTION, true);

      if (stopOrModify === BUTTONS_OPTIONS.MODIFY) {
        sessionStorage.setItem(
          'subscriptionDataToModify',
          JSON.stringify(currentSubscription)
        );

        this.router.navigate(['../modify'], {
          relativeTo: this.activatedRoute,
        });
      } else {
        sessionStorage.setItem(
          'subscriptionDataToStop',
          JSON.stringify(currentSubscription)
        );

        this.router.navigate(['../stop'], { relativeTo: this.activatedRoute });
      }
    } catch (error) {
      console.error('Error searching subscription', error)
      this.resetDisabledAndSpinners();
    }
  }

  modifyButtonClassByDisabled(): string {
    if (!this.areButtonsDisabled) return 'modify-subscription-button';
    return 'button-disable';
  }

  private resetDisabledAndSpinners() {
    this.areButtonsDisabled = false;
    this.showModifySpinner = false;
    this.showStopSpinner = false;
  }

  public goToApvHome() {
    this.router.navigate([SUBSCRIPTION_URLS.accountDetail]);
  }
}
